export const extractEntityInfo = data => {
  return {
    assignedUserId: data.assignedUserId,
    assignedUserName: data.assignedUserName,
    documentsIssuesCount: data.documentsIssuesCount,
    importantPersonnelIssuesCount: data.importantPersonnelIssuesCount,
    riskLevel: data.riskLevel,
    status: data.status,
    name: data.personalInformation.name,
    countryId: data.personalInformation.jurisdictionOfIncorporationId,
    stateProvinceId: data.personalInformation.jurisdictionOfIncorporationStateProvince,
    kycIssues: data.kycIssues,
    amlIssues: data.amlIssues,
    nextReview: data.nextReview,
    affiliatedEntitiesReviewRequired: data.affiliatedEntitiesReviewRequired,
    addressIssues: data.addressIssues,
    riskScore: data.personalInformation.score,
    riskLevelCalculationMethod: data.riskLevelCalculationMethod,
    riskLevelEnabled: data.riskLevelEnabled,
    pendingDeletion: data.pendingDeletion,
  };
};
